export default {
  likes: { name: 'likes' },
  shares: { name: 'shares' },
  comments: { name: 'comments' },
  videoplays: { name: 'video plays' },
  followers: { name: 'followers' },
  unknown: { name: 'unknown' },
};
